import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "loader"
}
const _hoisted_3 = { key: 2 }

import { withDefaults, computed } from 'vue'

  interface IPropsButton {
    buttonText?: string
    classList?: string 
    isDisabled?: boolean
    isLoading?: boolean 
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonIcon',
  props: {
    buttonText: { default: '' },
    classList: { default: '' },
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'click', val?: any): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { buttonText: string, classList: string, isDisabled: boolean, isLoading: boolean }

  

  

  const handleClick = (event: MouseEvent) => {
    emit('click', event)
  }

  const computedClass = computed(() => `${props.classList} ${props.isDisabled || props.isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-200'}`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([_unref(computedClass), "flex items-center space-x-2 p-2 rounded transition-colors"]),
    disabled: __props.isDisabled || __props.isLoading,
    onClick: handleClick
  }, [
    (!__props.isLoading)
      ? _renderSlot(_ctx.$slots, "icon", { key: 0 })
      : _createCommentVNode("", true),
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (__props.buttonText)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.buttonText), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})